/* 谷仓 数据字典 */

// 联系人客户类型
export const customerTypeEnum = [
  { value: 1, label: '个人' },
  { value: 2, label: '企业' }
]
// 成交客户评级
export const customerGradeEnum = [
  { value: 1, label: '⭐' },
  { value: 2, label: '⭐⭐' },
  { value: 3, label: '⭐⭐⭐' },
  { value: 4, label: '⭐⭐⭐⭐' },
  { value: 5, label: '⭐⭐⭐⭐⭐' },
  { value: 6, label: '⭐⭐⭐⭐⭐⭐' }
]
// 客户阶段  2潜在客户阶段；3签约客户阶段；8成交客户
export const customerPhaseEnum = [
  { value: 2, label: '潜在客户' },
  { value: 3, label: '签约客户' },
  { value: 4, label: '成交客户' }
]
// 客户阶段  2潜在客户阶段；3签约客户阶段；8成交客户
export const clueAndcustomerPhaseEnum = [{ label: '线索阶段', value: 1 }, ...customerPhaseEnum]
// 潜在客户状态
export const potentialStatusEnum = [
  { value: 10, label: '谈判', desc: '一切协商、交涉、商量、磋商等', color: '#EF8D3C' },
  { value: 12, label: '搁置', desc: '半年内无法达成合作', color: '#EF8D3C' },
  { value: 14, label: '归档', desc: '无合作可能', color: '#DF443B' }
]
// 签约客户状态
export const contractStatusEnum = [
  { label: '对接中', value: 20, color: '#EF8D3C' },
  { label: '暂停合作', value: 21, color: '#EF8D3C' },
  { label: '终止合作', value: 22, color: '#DF443B' }
]
// 成交客户状态
export const clientsStatusEnum = [
  { label: '磨合', value: 31, desc: '首次发货到 6 个月以内的客户', color: '#EF8D3C' },
  { label: '上涨', value: 32, desc: '业务量上涨的客户', color: '#EF8D3C' },
  { label: '下降', value: 33, desc: '业务量下降的客户', color: '#EF8D3C' },
  { label: '保持', value: 35, desc: '业务量稳定的客户', color: '#EF8D3C' },
  { label: '流失', value: 36, desc: '停止合作的客户', color: '#DF443B' }
]
// 收藏筛选状态
export const favoriteStatus = [
  {
    label: '默认',
    value: 0
  },
  {
    label: '收藏优先',
    value: 1
  },
  {
    label: '仅看收藏',
    value: 2
  }
]
export const customerAllStatusEnum = [
  { label: '线索公海池', value: 0 },
  { label: '待领取', value: 1 },
  { label: '待跟进', value: 2 },
  { label: '跟进中', value: 3 },
  { label: '无效线索', value: 5 },
  { label: '已转换', value: 8 },
  { label: '谈判', value: 10 },
  { label: '已注册', value: 11 },
  { label: '搁置', value: 12 },
  { label: '无合作可能', value: 13 },
  { label: '归档', value: 14 },
  { label: '对接中', value: 20 },
  { label: '暂停合作', value: 21 },
  { label: '终止合作', value: 22 },
  { label: '已签约', value: 30 },
  { label: '磨合', value: 31 },
  { label: '上涨', value: 32 },
  { label: '下降', value: 33 },
  { label: '稳定', value: 34 },
  { label: '保持', value: 35 },
  { label: '流失', value: 36 }
]
// ark账号状态
export const arkCodeStatusEnum = [
  { value: 0, label: '待审核' },
  { value: 1, label: '审核不通过' },
  { value: 2, label: '审核通过' },
  { value: 3, label: '已停用' },
  { value: 4, label: '冻结' },
  { value: 5, label: '限制' }
]
// 主题状态枚举
export const mainBodyStatusEnum = [
  { value: 0, label: '待审核' },
  { value: 1, label: '审核不通过' },
  { value: 2, label: '审核通过' },
  { value: 3, label: '已停用' },
  { value: 4, label: '已作废' },
  { value: 5, label: '草稿' },
  { value: 6, label: '待签约' }
]
// 客户未跟进天数
export const customerUnfollowDayTypeEnum = [
  { value: 1, label: '3天以内' },
  { value: 2, label: '7天以内' },
  { value: 3, label: '15天以内' },
  { value: 4, label: '超过15天' }
]
// 剩余跟进天数类型 超时（小于0天）、3天以内（0-3天）、7天以内、15天以内、超过15天
export const remanentFollowDayTypeEnum = [
  { value: 5, label: '超时' },
  { value: 1, label: '3天以内' },
  { value: 2, label: '7天以内' },
  { value: 3, label: '15天以内' },
  { value: 4, label: '超过15天' }
]
//
export const flagEnum = [
  { value: 1, label: '是' },
  { value: 0, label: '否' }
]
export const enterpriseScaleEnum = [
  { value: 1, label: '1~100人' },
  { value: 2, label: '100~500人' },
  { value: 3, label: '500~1000人' },
  { value: 4, label: '1000人以上' }
]
export const contactTypeEnum = [
  { value: 1, label: '法人' },
  { value: 2, label: '收货人' }
]
// 性别
export const genderEnum = [
  { value: 1, label: '男' },
  { value: 2, label: '女' }
]
/* 联系人角色类型 */
export const linkRoleTypeEnum = [
  { value: 1, label: '采购者' },
  { value: 2, label: '决策者' },
  { value: 3, label: '使用者' }
]
// 商机状态 初步接洽-确认需求-制定方案-达成合作-完结（未能合作、关闭与完结同级）
export const businessStatusEnum = [
  { label: '初步接洽', value: 1, color: '#EF8D3C', disabled: false, desc: '首次接触客户，例如首次电话、拜访联系等' },
  { label: '确认需求', value: 2, color: '#EF8D3C', disabled: false, desc: '确认客户有海外仓需求' },
  { label: '制定方案', value: 4, color: '#EF8D3C', disabled: false, desc: '制定合作方案，解决双方合作的疑难问题' },
  { label: '达成合作', value: 5, color: '#EF8D3C', disabled: false, desc: '签订合同，达到合作目的' },
  { label: '未能合作', value: 6, color: '#DF443B', disabled: false, desc: '半年内不能达成合作的客户' },
  { label: '完结', value: 7, color: '#3FAC46', disabled: false, desc: '在预计成交时间前，销售额达到商机填写的预计销售额的状态，成交商机的最终状态，不支持任何修改' },
  { label: '关闭', value: 8, color: '#DF443B', disabled: false, desc: '商机因客观原因无法达成合作或完结的状态' }
]
// 商机订单类型枚举
export const orderTypeEnum = [
  { label: '头程', value: 1 },
  { label: '尾程', value: 2 }
]
// 商机订单类型枚举
export const chanceTimoutFilterEnum = [
  { label: '是', value: true },
  { label: '否', value: false }
]
// 异动类型枚举
export const alarmTypeEnum = [
  { label: '激活异动', value: 1 },
  { label: '流失异动', value: 2 },
  { label: '余额异动', value: 3 },
  { label: '入库异动', value: 4 },
  { label: '出库异动', value: 5 },
  { label: '在库异动', value: 6 },
  { label: '出库增长异动', value: 7 },
  { label: '入库增长异动', value: 8 }
]

// 异动等级枚举
export const alarmLevelEnum = [
  { label: '一级异动', value: 1 },
  { label: '二级异动', value: 2 },
  { label: '三级异动', value: 3 }
]

// 异动客户等级枚举
export const alarmCustomerLevelEnum = [
  { label: '0-5万', value: 1 },
  { label: '5万-20万', value: 2 },
  { label: '20万-50万', value: 3 },
  { label: '50万以上', value: 4 }
]

// 异动处理状态枚举
export const alarmProcessStatusEnum = [
  { label: '未反馈', value: 1 },
  { label: '超时未反馈', value: 2 },
  { label: '已反馈', value: 3 },
  { label: '超时已反馈', value: 4 }
]

export default {
  customerTypeEnum,
  customerPhaseEnum,
  potentialStatusEnum,
  contractStatusEnum,
  clientsStatusEnum,
  customerAllStatusEnum,
  customerUnfollowDayTypeEnum,
  flagEnum,
  enterpriseScaleEnum,
  contactTypeEnum,
  genderEnum,
  linkRoleTypeEnum,
  clueAndcustomerPhaseEnum,
  businessStatusEnum,
  orderTypeEnum,
  arkCodeStatusEnum,
  remanentFollowDayTypeEnum,
  alarmTypeEnum,
  alarmLevelEnum,
  alarmCustomerLevelEnum,
  alarmProcessStatusEnum,
  favoriteStatus
}
